import type { ToolUseItem } from '@heidi/agents/contracts';
import type { IntlShape } from 'react-intl';

import {
  renderStandardExportToolUse,
  type OpenExportDocumentPayload,
} from './shared/exportDocumentPreview';

export const renderExportToWordToolUse = (
  item: ToolUseItem,
  intl: IntlShape,
  onOpenDocumentExport?: (payload: OpenExportDocumentPayload) => void
): JSX.Element | null =>
  renderStandardExportToolUse(
    item,
    intl,
    {
      artefactType: 'word',
      titleFallback: { id: 'pjArtEwd05', defaultMessage: 'Word export' },
    },
    onOpenDocumentExport
  );
